{
  "billing": {
    "title": "Facturación",
    "page_title": "Facturación y planes",
    "page_content": "Puedes cambiar y administrar tu plan de suscripción y editar tus detalles de pago.",
    "in_arrears_error": {
      "title": "Método de pago faltante o no válido",
      "content": "Tu cuenta está suspendida actualmente. Actualiza tus detalles de pago para activar tu cuenta"
    },
    "cancelled_error_payed": {
      "title": "La suscripción actual está cancelada",
      "content_1": "Se ha cancelado tu cuenta. Por favor",
      "content_2": "póngase en contacto con nosotros",
      "content_3": "para reactivar tu cuenta"
    },
    "cancelled_error_trial": {
      "title": "Tu período de prueba ha terminado",
      "content": "Se ha cancelado tu cuenta. Cambia tu plan a un plan de pago para seguir usando Iventis."
    },
    "subscription_box": {
      "title": "Suscripción",
      "current_plan": "Plan actual",
      "next_payment": "Próximo pago",
      "renews_on": "Se renueva el",
      "paid": "Pagado",
      "days": "para ir",
      "get_in_touch": "Ponte en contacto para hablar sobre tu plan",
      "Trial": "Juicio",
      "Active": "Activo",
      "Cancelled": "Cancelado",
      "InArrears": "¿En mora"
    },
    "change_plan": "Cambiar de plan",
    "payment_details_box": {
      "title": "Detalles de pago",
      "payment_method": "Método de pago",
      "card_ending": "Tarjeta que termina en",
      "expires": "Caduca",
      "billing_address": "Dirección de facturación",
      "no_payment_method": "Sin método de pago",
      "payment_breakdown_project": "{{ amount }} (1 proyecto x {{ amount }}",
      "payment_breakdown_users": "{{ totalAmount }} {{ maxUsers }} usuarios x {{ userAmount }}",
      "payment_breakdown_user": "{{ totalAmount }} (1 usuario x {{ totalAmount }}",
      "users": "usuarios",
      "user": "usuario",
      "discount": "descuento"
    },
    "redirect_modal": {
      "title": "Editar método de pago",
      "content": "Serás redirigido a nuestro proveedor de facturación para editar tus detalles de pago."
    },
    "excludes_taxes": "Excluye cualquier impuesto aplicable"
  },
  "upgrade_plan_warnings": {
    "upgrade_plan": "Plan de mejora",
    "contact_us": "Póngase en contacto con nosotros",
    "view_plans": "Ver planes"
  },
  "view_plans": "Ver planes",
  "subscription_details": {
    "title": "Detalles de la suscripción",
    "selected_plan": "Plan seleccionado",
    "plan_type": "Tipo de plan",
    "currency": "Moneda",
    "billed": "Facturado",
    "payment_date": "Fecha de pago",
    "payment_date_desc": {
      "Monthly": "{{ date }} de cada mes",
      "Annually": "{{ date }}"
    },
    "renewal_date": "Fecha de renovación",
    "add_users": "Agregar usuarios",
    "add_payment_method": "Añadir método de pago",
    "cannot_switch_from_annual": "Ponte en contacto con nosotros si necesitas cambiar de una facturación anual a una mensual",
    "exceeded_max_users_message": "Ponte en contacto con nosotros para analizar tus requisitos si necesitas más de {{ numberOfUsers }} usuarios",
    "continue_to_payment": "Continúa con el pago",
    "redirect_modal": {
      "title": "Editar suscripción",
      "message": "Al hacer clic en continuar, se te redirigirá a nuestro proveedor de facturación para que realices los pagos necesarios para la suscripción actualizada"
    },
    "update_successful": "La suscripción se actualizó correctamente"
  },
  "subscription_price_breakdown": {
    "title": "Desglose de precios",
    "subscription_fee": "Cuota de suscripción",
    "individual_price_breakdown": "Desglose de precios individuales",
    "discount_applied": "Descuento aplicado",
    "discount_has_been_applied": "Se ha aplicado automáticamente un descuento de {{ discount }} a tu cuenta",
    "total": "Total",
    "frequency_proice_breakdown": "Desglose de precios de {{ frequency }}",
    "frequency": {
      "Monthly": "Mensual",
      "Annually": "Anualmente"
    },
    "time_unit": {
      "Monthly": "meses",
      "Annually": "año"
    },
    "users": "usuarios",
    "excludes_taxes": "Excluye cualquier impuesto aplicable que se añadirá en la página de pago"
  },
  "subscription_payment_breakdown": {
    "title": "Desglose de pagos",
    "vat": "IVA {{ percentage }} sobre el {{ total }}",
    "total_excluding_tax": "Total sin impuestos",
    "amount_due": "Importe adeudado",
    "description": "Descripción",
    "total": "Total",
    "unit": "Unidad",
    "pay": "Paga {{ amount }}"
  },
  "order_summary": "Resumen del pedido",
  "settings": "Ajustes"
}